import React from 'react';
import styled from 'styled-components'

import { Table, CSVButton, PDFButton } from '../common';
import { Box, numberToCurrency } from 'vqp-common'
import { CardTitle } from './'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Card = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
`

const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-self: flex-end;
    justify-content: space-between;
    margin-top: 20px;
    width: 300px;
`

const makeCSVHeaders = (columns) => (
    columns.map(col => ({
        label: col.Header,
        key: col.accessor
    }))
)

export const ProductsRanking = ({products}) => {

    const columns = [
        {
            Header: '#',
            accessor: 'ranking',
            maxWidth: 40
        },
        {
            Header: 'Produto',
            accessor: 'name',
        },
        {
            Header: 'Pedidos',
            accessor: 'quantity',
            maxWidth: 70
        },
        {
            Header: 'Valor',
            accessor: 'value',
            maxWidth: 90,
            Cell: props => (numberToCurrency(props.value))
        }
    ]

    const TableComponent = () => (
        <Table
            className="-striped"
            data={products}
            columns={columns}
            minRows={20}
            getTrProps={() => ({
                style: {
                    height: '50px',
                }
            })}
            getTdProps={() => ({
                style: {
                    alignSelf: 'center'
                }
            })}
        />
    )
    
    return (
        <Wrapper>
            <CardTitle>Ranking de Produtos</CardTitle>
            <Card>
                <TableComponent />
            </Card>
            <ActionsContainer>
                <CSVButton 
                    headers={makeCSVHeaders(columns)} 
                    data={products}
                    title="RankingProdutos" />
                <PDFButton 
                    headers={makeCSVHeaders(columns)} 
                    data={products}
                    title="RankingProdutos" />
            </ActionsContainer>
        </Wrapper>
    )
}

